import AbsenceLetter from "../absence-letter";

import { Icon } from "../../../../components/icon";

import { absenceLetterRoutes } from "./kcq/absence-letter.routes";
import { employeeConfirmationRoutes } from "./kcq/employee-confirmation.routes";
import CourseStaff from "../course-staff";
import { courseStaffRoutes } from "./kcq/course-staff";
import SummaryEmployeeRequest from "../summary-employee-request";
import { summaryEmployeeRequestRoutes } from "./kcq/summary-employee-request";
import { monthlyTrainingPlanRoutes } from "./kcq/monthly-training-plan";
import { summaryRegistrationCourses } from "./kcq/summary-registration-courses";
import { monthlyTrainingPlanSummaryRoutes } from "./kcq/monthly-training-plan-summary";
import { meetingRoomRoutes } from "./kcq/meeting-room";
import { sickLeaveDADRoutes } from "./dad/afl-sick-leave.routes";
import { noSalaryLeaveDADRoutes } from "./dad/afl-no-salary-leave.routes";
import { absenceLetterDADRoutes } from "./dad/absence-letter-dad.routes";
import { maternityLeaveDADRoutes } from "./dad/afl-maternity-leave.routes";
import { absenceLetterNBARoutes } from "./nba/absence-letter-nba.routes";
import { suspendContractDADRoutes } from "./dad/afl-suspend-contract.routes";
import { terminationContractDADRoutes } from "./dad/afl-termination-contract.routes";

export const humanOrganizationRoutes = {
  humanOrganizationDepartment: {
    isAdmin: false,
    title: "TỔ CHỨC NHÂN LỰC",
    path: "/procedure/human-organization",
    icon: <Icon.Collection />,
    parentId: "procedure",
  },
  ...absenceLetterRoutes,
  // ...applicationForLeaveRoutes,
  ...employeeConfirmationRoutes,
  ...courseStaffRoutes,
  ...summaryEmployeeRequestRoutes,
  ...monthlyTrainingPlanRoutes,
  ...monthlyTrainingPlanSummaryRoutes,
  ...summaryRegistrationCourses,
  ...meetingRoomRoutes,

  identifyEmployeesPage: {
    isAdmin: false,
    title: "3. Xác nhận nhân viên",
    path: "/procedure/identify-employees",
    parentId: "procedure",
    component: AbsenceLetter,
  },

  coursePersonChangeFormPage: {
    isAdmin: false,
    title: "2. Phiếu thay đổi/bổ sung nhân sự khóa học",
    path: "/procedure/course-person-change-form",
    parentId: "procedure",
    component: CourseStaff,
  },

  personRegisteredCourse: {
    isAdmin: false,
    title: "3. Bảng đăng ký nhân sự tham gia khoá học",
    path: "/procedure/person-registered-course",
    parentId: "procedure",
    component: SummaryEmployeeRequest,
  },
  totalEmployeesForm: {
    isAdmin: false,
    title: "7. Phiếu tổng hợp nhân sự",
    path: "/procedure/total-employees-form",
    parentId: "procedure",
    component: AbsenceLetter,
  },
};

export const applicationForLeaveNBARoutes = {
  aflNBA: {
    isAdmin: false,
    title: "CHI NHÁNH NỘI BÀI",
    path: "/procedure/afl-nba",
    icon: <Icon.NBA />,
    parentId: "procedure",
  },
  ...absenceLetterNBARoutes,
};

export const applicationForLeaveDADRoutes = {
  aflDAD: {
    isAdmin: false,
    title: "CHI NHÁNH ĐÀ NẴNG",
    path: "/procedure/afl-dad",
    icon: <Icon.DAD />,
    parentId: "procedure",
  },
  ...absenceLetterDADRoutes,
  ...maternityLeaveDADRoutes,
  ...sickLeaveDADRoutes,
  ...noSalaryLeaveDADRoutes,
  ...suspendContractDADRoutes,
  ...terminationContractDADRoutes,
};
